let i18nOverrideEnabled = false;

export const configureTextResolver = ({ useI18nOverride } = {}) => {
  if (typeof useI18nOverride === 'boolean') {
    i18nOverrideEnabled = useI18nOverride;
  }

  return i18nOverrideEnabled;
};

export const isI18nOverrideEnabled = () => i18nOverrideEnabled;

const resolveTextInternal = ({ intl, intlKey, fallback, values = {}, defaultMessage }) => {
  if (isI18nOverrideEnabled() && intl && intlKey) {
    return intl.formatMessage(
      { id: intlKey, defaultMessage: defaultMessage || fallback },
      values
    );
  }

  return fallback;
};

export const resolveText = ({ intl, intlKey, fallback, values = {}, defaultMessage } = {}) =>
  resolveTextInternal({
    intl,
    intlKey,
    fallback,
    values,
    defaultMessage,
  });

export const resolveTextByKey = (intl, intlKey, fallback, values = {}, defaultMessage) =>
  resolveTextInternal({
    intl,
    intlKey,
    fallback,
    values,
    defaultMessage,
  });
